var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "13px",
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn_phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dealer-Info",
    transform: "translate(-16.000000, -107.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_phone",
    transform: "translate(14.000000, 105.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_phone"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.666667, 2.666667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C0,5.89103733 4.77562934,10.6666667 10.6666667,10.6666667 L10.6666667,10.6666667",
    id: "Oval-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.05083057e-14 L4,-7.53122246e-09 L4,3.33333333 L0.775356063,4 C0.275342846,2.76475809 0,1.41453393 0,3.05083057e-14 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6666667,10.6666667 L10.6666667,6.66666667 L7.33333333,6.66666667 L6.66666667,9.8913106 C7.90190858,10.3913238 9.25213274,10.6666667 10.6666667,10.6666667 Z",
    id: "Combined-Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPhone);
export default __webpack_public_path__ + "static/media/icn_phone.ffd70bf57f5fec246f211e29e99db87b.svg";
export { ForwardRef as ReactComponent };